import { Component, Event, EventEmitter, h, State } from '@stencil/core';
import { signInWithEmailAndPassword } from '@firebase/auth';
import { FirebaseService } from '../../utils/firebase';
import { inputOut } from '../../utils/utils';


@Component({
  tag: 'tambr-auth-login',
  styleUrl: 'tambr-auth-login.css',
  shadow: false
})
export class TambrAuthLogin {

  email: string = '';
  password: string = '';

  @State() errorMessages: string[] = [];
  @State() loading: boolean;

  @Event() tambrChangeLoginForm: EventEmitter<string>;

  handleEmailChange( event ) { this.email = event.target.value; }
  handlePasswordChange( event ) { this.password = event.target.value; }

  addErrorMessage( message: string ) { this.errorMessages = [ ...this.errorMessages, message ]; }

  validate() {
    if (this.email == '') this.addErrorMessage(`Email address can't be empty`);
    if (this.password == '') this.addErrorMessage(`Password field can't be empty`);
  }

  async handleSubmit(ev: any) {
    ev.preventDefault();
    this.errorMessages = [];

    this.validate();
    if ( this.errorMessages.length ) return;

    this.loading = true;
    try {
      await signInWithEmailAndPassword( FirebaseService.auth, this.email, this.password );

    } catch ( error ) {
      switch( error.code ) {
        case 'auth/invalid-email': this.addErrorMessage('Email address is not valid.'); break;
        case 'auth/wrong-password': this.addErrorMessage('Wrong password.'); break;
        case 'auth/too-many-requests': this.addErrorMessage('Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later.'); break;
        case 'auth/user-disabled': this.addErrorMessage('User corresponding to the given email has been disabled.'); break;
        case 'auth/user-not-found': this.addErrorMessage('There is no user corresponding to the given email.'); break;  
        default: this.addErrorMessage(error.message)
      }
    }    
    this.loading = false;
  }

  renderMessages( messages: string[] ) {
    return ( <ul>{ messages.map( (message: string) => <li>{ message }</li> ) }</ul> );
  }

  render() {
    return (
      <form id='tambr-login-form' class='tambr-auth-form' onSubmit={ ev => this.handleSubmit(ev) }>
        <div class={'error message' + (this.errorMessages.length ? ' show' : '') }>
          { this.renderMessages(this.errorMessages) }
        </div>

        <div class='tambr-form-item'>
          <input type='email' id='email' onBlur={ (event) => inputOut(event) } 
            name='email' value={ this.email } autocomplete='off' 
            onInput={ (event) => this.handleEmailChange(event) }/>
          <label htmlFor='email'>Email</label>
        </div>

        <div class='tambr-form-item'>
          <input type='password' id='password' name='password' 
            onBlur={ (event) => inputOut(event) } value={this.password}
            onInput={ (event) => this.handlePasswordChange(event) }/>
          <label htmlFor='password'>Password</label>
        </div>
        <div class='password-recovery-link'>
          <a onClick={ () => this.tambrChangeLoginForm.emit('reset') }>Forgot your password?</a>
        </div>        

        <div class='tambr-action-buttons'>
          <button type='submit' disabled={ this.loading }
            class={ 'tambr-button' + (this.loading ? ' loading' : '') }>
              <div class='tambr-button-loading'><div>Loading...</div></div>
              <span>Log in</span>
          </button>

          <a class='tambr-clear-button' onClick={ () => this.tambrChangeLoginForm.emit('signup') }>Sign up</a>
        </div>
      </form>
    )
  }

}
